import actions from './constants';

export const showSaveCohort = (category, code) => ({
  type: actions.SHOW_SAVE_COHORT,
  category,
  code,
});

export const hideSaveCohort = () => ({ type: actions.HIDE_SAVE_COHORT });

export const createCohort = () => ({ type: actions.CREATE_COHORT });

export const addDictionaryToCohort = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.ADD_DICTIONARY_TO_COHORT,
  category,
  code,
  queryUUID,
  dictionaryCode,
});

export const removeDictionaryFromCohort = (category, code, queryUUID, dictionaryCode) => ({
  type: actions.REMOVE_DICTIONARY_FROM_COHORT,
  category,
  code,
  queryUUID,
  dictionaryCode,
});

export const datasetToCohort = (code, category, result, dictionaryCodes) => ({
  type: actions.DATASET_TO_COHORT,
  code,
  category,
  result,
  dictionaryCodes,
});

export const newCohort = (category, code, result) => ({
  type: actions.NEW_COHORT,
  category,
  code,
  result,
});

export const newCohortError = (error) => ({
  type: actions.NEW_COHORT_ERROR,
  error,
});

export const confirmCohortDeletion = (category, code) => ({
  type: actions.SHOW_DELETE_COHORT,
  category,
  code,
});

export const confirmCohortsDeletion = (category) => ({
  type: actions.SHOW_DELETE_COHORTS,
  category,
});

export const hideDeleteCohort = () => ({
  type: actions.HIDE_DELETE_COHORT,
});

export const updateCohortProperties = (category, code, properties) => ({
  type: actions.UPDATE_COHORT_PROPERTIES,
  category,
  code,
  properties,
});

export const updateActiveCohortProperties = (properties) => ({
  type: actions.UPDATE_ACTIVE_COHORT_PROPERTIES,
  properties,
});

export const fetchCohorts = (category, page, pageSize, append) => ({
  type: actions.FETCH_COHORTS,
  category,
  page,
  pageSize,
  append,
});

export const refreshCohorts = (category, page) => ({
  type: actions.REFRESH_COHORTS,
  category,
  page,
});

export const toggleCohortSelected = (category, code) => ({
  type: actions.TOGGLE_COHORT_SELECTED,
  category,
  code,
});

export const toggleCohortsSelected = (category, selected) => ({
  type: actions.TOGGLE_COHORTS_SELECTED,
  category,
  selected,
});

export const updateCohortsFilter = (category, value) => ({
  type: actions.UPDATE_COHORTS_FILTER,
  category,
  value,
});

export const updateCohortsFlags = (category, { privateFlag, internalFlag }) => ({
  type: actions.UPDATE_COHORTS_FLAGS,
  category,
  privateFlag,
  internalFlag,
});

export const showCohorts = (category, append, pageSize, results, resultsCount, totalPages, currentPage) => ({
  type: actions.SHOW_COHORTS,
  category,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const showCohortsError = (category, error) => ({
  type: actions.SHOW_COHORTS_ERROR,
  category,
  error,
});

export const closeCohorts = ({ category }) => ({
  type: actions.CLOSE_COHORTS,
  category,
});

export const fetchCohort = (category, code, isNew) => ({
  type: actions.FETCH_COHORT,
  category,
  code,
  isNew,
});

export const updateCohortCancel = (category, code) => ({
  type: actions.UPDATE_COHORT_CANCEL,
  category,
  code,
});

export const showCohort = (category, code, result, isNew) => ({
  type: actions.SHOW_COHORT,
  category,
  code,
  result,
  isNew,
});

export const showCohortError = (category, code, error) => ({
  type: actions.SHOW_COHORT_ERROR,
  category,
  code,
  error,
});

export const deleteCohort = ({ items }) => ({
  type: actions.DELETE_COHORT,
  items,
});

export const destroyCohort = (items, silent) => ({
  type: actions.DESTROY_COHORT, items, silent,
});

export const destroyCohortError = (items) => ({
  type: actions.DESTROY_COHORT_ERROR, items,
});

export const closeCohort = ({ category, code }) => ({
  type: actions.CLOSE_COHORT,
  category,
  code,
});

export const updateCohort = (category, code, properties) => ({
  type: actions.UPDATE_COHORT,
  category,
  code,
  properties,
});

export const editCohort = (category, code) => ({
  type: actions.EDIT_COHORT,
  category,
  code,
});

export const editCohortSuccess = (code, result) => ({
  type: actions.EDIT_COHORT_SUCCESS,
  code,
  result,
});

export const editCohortError = (category, code, error) => ({
  type: actions.EDIT_COHORT_ERROR,
  category,
  code,
  error,
});

export const updateCohortPanels = (code, category, queryUUID) => ({
  type: actions.UPDATE_COHORT_PANELS,
  code,
  category,
  queryUUID,
});

export const newCohortFromDataset = (code, category, datasetCode, dictionaryCodes) => ({
  type: actions.NEW_COHORT_FROM_DATASET,
  code,
  category,
  datasetCode,
  dictionaryCodes,
});

export const fetchCohortDatasets = (category, code, page, pageSize, append) => ({
  type: actions.FETCH_COHORT_DATASETS,
  category,
  code,
  page,
  pageSize,
  append,
});

export const updateCohortDatasetsFilter = (category, code, value) => ({
  type: actions.UPDATE_COHORT_DATASETS_FILTER,
  category,
  code,
  value,
});

export const toggleCohortDatasetSelected = (category, code, datasetCode) => ({
  type: actions.TOGGLE_COHORT_DATASET_SELECTED,
  category,
  code,
  datasetCode,
});

export const updateCohortDatasetsFlags = (category, code, { privateFlag, internalFlag, publicFlag }) => ({
  type: actions.UPDATE_COHORT_DATASETS_FLAGS,
  category,
  code,
  privateFlag,
  internalFlag,
  publicFlag,
});

export const showCohortDatasets = (
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_COHORT_DATASETS,
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const fetchCohortDictionaries = (category, code, page, pageSize, append) => ({
  type: actions.FETCH_COHORT_DICTIONARIES,
  category,
  code,
  page,
  pageSize,
  append,
});

export const updateCohortDictionariesFilter = (category, code, value) => ({
  type: actions.UPDATE_COHORT_DICTIONARIES_FILTER,
  category,
  code,
  value,
});

export const toggleCohortDictionarySelected = (category, code, dictionaryCode) => ({
  type: actions.TOGGLE_COHORT_DICTIONARY_SELECTED,
  category,
  code,
  dictionaryCode,
});

export const showCohortDictionaries = (
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
) => ({
  type: actions.SHOW_COHORT_DICTIONARIES,
  category,
  code,
  append,
  pageSize,
  results,
  resultsCount,
  totalPages,
  currentPage,
});

export const toggleExpandedCharts = (category, code) => ({
  type: actions.TOGGLE_EXPANDED_CHARTS,
  category,
  code,
});

export const toggleCohortsPresentation = (category, display) => ({
  type: actions.TOGGLE_COHORTS_PRESENTATION,
  category,
  display,
});
